import { render } from "./AcceptanceTermsOffcanvas.vue?vue&type=template&id=1994da16&scoped=true"
import script from "./AcceptanceTermsOffcanvas.vue?vue&type=script&lang=js"
export * from "./AcceptanceTermsOffcanvas.vue?vue&type=script&lang=js"

import "./AcceptanceTermsOffcanvas.vue?vue&type=style&index=0&id=1994da16&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1994da16"]])

export default __exports__